import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface FeaturedSectionProps {
  movie: Movie;
}

export default function FeaturedSection({ movie }: FeaturedSectionProps) {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="relative rounded-xl overflow-hidden h-[300px] md:h-[400px] group">
        <img
          src={movie.cover}
          alt={movie.title}
          title={`${movie.title} - 八戒影院推荐`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/90 via-background-50/50 to-transparent" />
        <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-10">
          <span className="inline-flex items-center gap-1 text-accent-400 text-xs font-bold tracking-wider uppercase">
            <i className="ri-vip-crown-line" /> 今日推荐
          </span>
          <h2 className="mt-2 text-2xl md:text-4xl font-heading font-black text-foreground-950">
            {movie.title}
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-xl line-clamp-2">
            {movie.description}
          </p>
          <div className="mt-3 flex items-center gap-4 text-sm text-foreground-600">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-primary-500" />
              {movie.rating}
            </span>
            <span>{movie.year}</span>
            <span>{movie.genres.join(' / ')}</span>
            <span>{movie.episodes}</span>
          </div>
          <div className="mt-4">
            <Link
              to={`/detail/${movie.id}`}
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-950 font-semibold rounded-full text-sm hover:bg-primary-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-play-circle-fill text-lg" />
              立即观看
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}